module.exports = {
  common: {
    edit: "Editor",
    apply: "Application",
    activate: "activation",
    delete: "Delete",
    cancel: "Cancel",
    success: "Success",
    fail: "Failure",
    save: "Save",
    ensure: "OK",
    submit: "Submit",
    remark: "Note",
    detail: "View",
    action: "Operation",
    open: "turned on",
    close: "off",
    back: "Return",
    export: "Export",
    modify: "To modify",
    layout: "Exit login",
    noListData: "list without data",
    more: "Details",
    add: "new",
    delSuccess: "Delete it successfully!",
    addFailure: "Add failed!",
    logOut: "Logout",
    delAllInfo: "Do you want to continue with the deletion operation?",
    saveTip:
      "You have not saved the page content, do you want to continue to leave again?",
    tip: "prompt",
    yes: "Yes",
    no: "No",
    delTip: "Check the activation",
    batchDelete: "Batch Delete",
    search: "search",
    permission: "No permission yet, please return",
    reset: "Reset",
  },
  breadcrumbItem: {
    home: "Name list configuration",
    data: "device universal configuration package",
    alarm: "Defense District",
    house: "Layout layout configuration",
    name: "Name list configuration",
  },
  errorRes: {
    res82: "The system is busy, please try again later",
  },

  openConfig: {
    title: "Device universal configuration",
    version: "protocol version",
    versionTip: "Please select the protocol version",
    checkVersion: "Agreement version must not be empty, please reselect",
    signType: "Signature algorithm type",
    checkSignType:
      "Signature algorithm type must not be empty, please re-select",
    fileLabel: "Select a file",
    addFile: "Add a file",
    fileName: "file name",
    zipType: "compressed file mode",
    noZip: "No compression",
    noFile: "No file yet added",
    checkFile: "Profile is empty, please add file",
    name: "Name",

    nameTip: "input length of 1-10 bits",
    checkName: "Name must not be empty, please re-enter",
    checkName1: "Wrong name input, please re-enter",
    room: "Device number",
    roomTip: 'The input length is 1-24 bits, by "-" distinguish hierarchy',
    checkRoom: "Device number must not be empty, please re-enter",
    checkRoom1: "Device number input error, please re-enter",
    pic: "Picture",
    add: "Add",
    reset: "Reset",
    picTip: "Picture file upload up to 3m",
    checkPic: "Picture file must not be empty, please reselect",
    imgRegTip: "Only allow to upload jpg, jpeg, png format files",
    excRegTip: "Only allow to upload xls, xlsx format files",
    zipRegTip: "Only allowed to upload files in zip format",
    produce: "Build a profile",
    confType: "configuration type",
    pack: "packing",
    batchAdd: "Batch Add",
    singleAdd: "Single Add",
    modelBatch: "Template",
    uploadInfo: "Upload Excel",
    uploadPic: "Upload Picture Zip",
    addName: "Add",
    sameTip: "Serial number：",
    sameTip1: ", Device number in duplicate",
    modelError:
      "The uploaded basic information file content is incorrect, please modify the file against the template",
    noPic: "No added data in the list, complete the configuration file",
    picBtnTip: "Please upload the basic information file",
    devType: "Device type",
    devTypeTip: "Please select the device type",
    checkDevType: "Device type must not be empty, please re-select",
    indexName: "Serial Number",
    IS: "IS",
    GU: "Guard",
    OS1: "Doorstation",
    OS2: "Perimetergate",
    OS3: "Minios",
    nameListTip:
      "In the basic data to be uploaded, some data whose name field is incomplete has been imported",
    numListTip:
      "In the basic data to be uploaded, the device ID field is incomplete. Other correct data has been imported",
  },
  alarm: {
    ad: "AD Defense District",
    io: "IO Defense District",
    alarmPlus: "Extend Defense District",
    num: "Number",
    open: "On",
    close: "Off",
    machine: "Detector Type",
    sendType: "Trigger Type",
    mode: "Mode",
    mType1: "Infrared",
    mType2: "Door Contact",
    mType3: "Window Magnetic",
    mType4: "Gas",
    mType5: "Smoke",
    mType6: "Doorbell",
    mType7: "Hand To Button",
    mType8: "Infrared Magnetic Door",
    mType9: "Hand Door Magnetic",
    mType10: "Vibration",
    mType11: "Air Pressure",
    mType12: "Other",
    send1: "Report within 24 hours",
    send2: "Delayed Alarm",
    send3: "Delivery time delay",
    send4: "Immediately report to the police",
    send5: "Cross alarm",
    mode1: "Normally open",
    mode2: "Often shut",
    presence: "At home,",
    leaving: "Away from home",
  },
  house: {
    dev: "Device",
    scene: "Scene",
    vine: "Sensor",
    single: "ControlModeOfScene",
    IndependentControl: "IndependentControl",
    light: "Light",
    air: "Air Conditioner",
    heat: "Underfloor Heating",
    fresh: "Fresh Air",
    switch: "Switch Socket",
    curtain: "Curtain",
    water: "Water Heater",
    bgm: "BGM",
    cust: "Custom-Device",

    slight: "Light",
    sAir: "AC",
    sHeat: "UFH",
    sFresh: "Fresh Air",
    sSwitch: "Socket",
    sCurtain: "Curtain",
    sWater: "WH",
    sBgm: "BGM",
    sCust: "Custom",

    IndependentControl: "Independent control scenario",
    scene1: "scene1",
    scene2: "scene2",
    scene3: "scene3",
    scene4: "scene4",
    scene5: "scene5",
    scene6: "scene6",
    scene7: "scene7",
    scene8: "scene8",
    temp1: "Temperature",
    temp2: "Humidity",
    temp3: "Methane",
    temp4: "TVOC",
    picTip: "There is no family plan",
    upload: "Upload the family plan",
    imgSize: "The picture size of a single house drawing shall not exceed 10M",
    imgName:
      "The name of the uploaded apartment layout file cannot appear in Chinese. Please select another name",

    imgLength:
      "The total number of house type maps uploaded and added shall not exceed 8. The first 8 pictures in the folder have been automatically selected",
    imgCheckTip: "The house map does not match. Please upload it again",
    room1: "Door model figure 1",
    room2: "Door model figure 2",
    room3: "Door model figure 3",
    room4: "Door model figure 4",
    room5: "Door model figure 5",
    room6: "Door model figure 6",
    room7: "Door model figure 7",
    room8: "Door model figure 8",
    download: "export",
    input: "Import the configuration",
    title: "Device Parameter List ",
    name: "name",
    location: "location",
    start: "start",
    see: "visible",
    noSee: "invisible",
    belong: "belong",
    bgIcon: "Blue ash icon",

    vineTip:
      "Please select the house type diagram before setting the temperature control attributes.",
    sceneTip: "Please select the house type and then set the scene properties",
    dragTip: "Please select the house model map, and then drag the operation.",

    editTip: "Editor success",
    addTip: "When uploading, you need to select all the house plans at once.",

    editError: "Please specify editing before editing.",
    delError: "Please specify the delete content before deleting.",
    delTip: "Deletion success",
    imgAddTip:
      "The total number of house type maps uploaded and added has reached 8, which cannot be added again",
    houseTitle: "Switching of house plan:",
    delHouseTip:
      "This operation will delete the house type map and the configuration content. Do you want to continue?",
    sendTip:
      "Import the configuration content and modify it again. You can upload the XML file",
    checkType:
      "The format of the uploaded file is incorrect. Check the file content and upload the file again",
    importTip: "Importing a Configuration File",
    importTip1: "Import the corresponding house type map",
    upLoadBtn: "Upload",
    picContent:
      "The uploading sequence of the household diagram must be the same as that in the configuration file",
    successFile: "Configuration file upload successfully",

    maxSizeTip:
      "The number of added devices or the total number of added devices exceeds the upper limit. If you want to add devices or scenarios, sort out the added devices or scenarios first",
    devNameTip: "Please enter name",
    chromeTip: "Chrome is recommended",
    downTip: "Click the jump to download link",
    imgRegTip: "Only allow to upload jpg, jpeg format files",
    threeTitle: "Three Constant System",
    mainControl: "Master",
    sedControl: "Branch",
    smSedControl: "Branch",
    controlBtn: "Config",
    configEdit: "Details about the Sanheng system configuration",
    moveTip:
      "Drag the icon to the area of the house type map, and then drag it again",
    repeatNameTip:
      "Cannot upload the same name of the apartment plan, please select another",
    space: "(reserve)",
  },
  updateConfig: {
    tip0: "Set the switch to open when set to 24 hours",
    tip1: "When 24 hours is set, the switch should be set to on",
    tip2: "When setting immediate alarm, the switch should be set to on",
    tip3: "When the delay alarm is off, the transmission delay should be set to off",
    tip4: "Cross alarm has been set and needs to be associated",
    tip5: "Please turn on the delay alarm first",
    tip6: "When setting immediate alarm, set the switch to on",
  },
  audio: {
    title: "Voice prompt packaging tool",
    lock: "Unlock prompt sound",
    call: "Call prompt tone",
    speak: "Speak prompt tone",
    busy: "Busy prompt sound",
    tip1: "Click to upload. wav format file",
    tip2: "File size does not exceed 1M",
    tip3: "Please upload a. wav format file",
    tip4: "Please upload all files",
    add: "Generate file",
  },
  threeProject: {
    hotWater: "Hot water system",
    cho: "Formaldehyde",
    config: "Configure",
    unconfig: "Do not configure",
  },
  elevator: {
    title: "Elevator Control Configuration Generator",
    label: "Upload Elevator Control Configuration Sheet",
    uploadTip: "Click or drag file to this area to upload",
    upload: "Upload",
    download: "Download Template",
    downloadTip: "Download",
    error1:
      "[Physical Floor] is invalid. Please check the configuration file and re-import.",
    error2:
      "[Display Floor] is invalid. Please check the configuration file and re-import.",
    error3:
      "[Elevator control gateway address] is invalid. Please check the configuration file and re-import.",
    error4:
      "[Display elevator number] is invalid. Please check the configuration file and re-import.",
    error5:
      "[Device IP] is invalid. Please check the configuration file and re-import.",
    error6:
      "[Elevator control gateway] count exceeds limit. Please check the configuration file and re-import.",
    generate: "Elevator Control Configuration Template",
    fileLabel: "Elevator Control Configuration File:",
    tip: "Please place the configuration file in the [Resource Upgrade] section of the PC tool to import it into the device.",
    downloadfile: "Download",
    fileName: "Elevator_Control_Configuration_File.xlsx",
    formatError:
      "The uploaded file format is incorrect. Please check the file content and re-upload.",
  },
};
